import { render } from "./Carta.vue?vue&type=template&id=563bfc1a&scoped=true"
import script from "./Carta.vue?vue&type=script&lang=js"
export * from "./Carta.vue?vue&type=script&lang=js"

import "./Carta.vue?vue&type=style&index=0&id=563bfc1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563bfc1a"]])

export default __exports__